module.exports = __webpack_public_path__ + "img/preston-logo.94522de0.png";